/**
 * Change gallery image via colour swatch selector
 */
var sirus_colorSwitcher = sirus_colorSwitcher || {};

( function( $, window, document, undefined ) {


	//  Default config settings
	sirus_colorSwitcher.config = {
			debug: false,
			container: '.color-swatches',
			button: '.color-swatches__item',
			image_container: '.js-vehicle-colors',
			label_container: '.js-color-swatches__name'
	};

	/**
	 * Setup debug check
	 * To turn debug on supply { debug: true } to the `init` function
	 */
	sirus_colorSwitcher.debug = function () {
		return sirus_colorSwitcher.config.debug;
	};

	sirus_colorSwitcher.init = function( config ) {

		// Provide for custom configuration via init().
		if ( config && typeof( config ) === 'object' ) {
			$.extend( sirus_colorSwitcher.config, config );
		}

		// Add event listerner
		var _clicked = $(sirus_colorSwitcher.config.button).on( 'click', function( event ) {
			event.preventDefault();
			sirus_colorSwitcher.getData( $( this ) );
		});
	};

	/**
	 * Get data from the attributes.
	 */
	sirus_colorSwitcher.getData = function( _button ) {
		var _image_color_name = _button.attr( 'data-image-color-name' );

		if ( sirus_colorSwitcher.debug() ) {
			console.log( 'getData', _image_color_name );
		}

		sirus_colorSwitcher.changeImage( _image_color_name );
		sirus_colorSwitcher.changeLabel( _image_color_name );

	};

	sirus_colorSwitcher.changeImage = function ( _image_color_name ) {
		var _image_container = $( sirus_colorSwitcher.config.image_container ),
				_slider = _image_container.find( 'img[data-vehicle-color="' + _image_color_name + '"]' ),
				_active = $( _slider.parent() ).not( '.slick-cloned' ).data('slick-index');

		if ( sirus_colorSwitcher.debug() ) {
			console.log( 'changeImage', _active );
		}

		// Go to slide in slick slider.
		$( _image_container ).slick( 'slickGoTo', _active );

	};

	sirus_colorSwitcher.changeLabel = function ( _image_color_name ) {
		var _label_container = $( sirus_colorSwitcher.config.label_container );

		if ( sirus_colorSwitcher.debug() ) {
			console.log( 'changeLabel', _image_color_name, _label_container );
		}

		// Update colour name.
		$( _label_container ).html( _image_color_name );

	};

} )( jQuery, window, document );

/* @TODO Move to own file included only on builder pages.
wp_add_inline_script(
	'sirus-colorSwitcher',
	';(function( $ ){ $(document).ready(function () {sirus_colorSwitcher.init();}); })( window.jQuery );'
);*/

;(function($,window,document,undefined){$(document).ready(function(){sirus_colorSwitcher.init();});})(jQuery,window,document);
